/*
There are mobile- and desktop apps that wrap this web app.
They need to listen to certain events.
*/
import _invoke from 'lodash/invoke'

export default function(eventName: string, params?: any): void {
  _invoke(window, `appWrapperHooks.${eventName}`, params)
}
